module.exports = __webpack_public_path__ + "static/media/iconAssistantActive.64657816.svg";